import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class DestinationFilesRoute extends Route
{
	@service store;

	model(params)
	{
		return this.store.findRecord('destination', params.destination_id);
	}
}
